/**
 * Created by Daniela on 26/09/2016.
 */
import { NgModule } from '@angular/core';

import { SharedModule} from "../../shared/shared.module";
import { ContaContabilRoutingModule } from "./conta-contabil.routing";
import { ContaContabilService } from "./shared/conta-contabil.service";
import { ContaContabilComponent } from "./conta-contabil.component";
import { ContaContabilFormComponent } from "./conta-contabil-form/conta-contabil-form.component";
import { ContaContabilTableComponent } from "./conta-contabil-table/conta-contabil-table.component";
import { ContaContabilListComponent } from "./conta-contabil-list/conta-contabil-list.component";
import { ContaContabilCodigoPipe } from "./shared/pipes/conta-contabil-codigo.pipe";
import { ContaContabilCodigoMaskDirective } from "./shared/directives/conta-contabil-codigo-mask.directive";
import { ContaContabilTipoApiService } from "./conta-contabil-tipos/shared/conta-contabil-tipo-api.service";
import { ContaContabilNavigationService } from "./shared/conta-contabil-navigation.service";
import { ContaContabilCodigoValidator } from "./shared/validators/contaContabilCodigo.validator";
import { ContaContabilApiService } from "./shared/conta-contabil-api.service";

@NgModule({
    imports: [
        SharedModule,
        ContaContabilRoutingModule
    ],
    providers: [
        ContaContabilService,
        ContaContabilNavigationService,
        ContaContabilService,
        ContaContabilApiService,
        ContaContabilCodigoValidator,
        ContaContabilTipoApiService
    ],
    declarations: [
        ContaContabilComponent,
        ContaContabilFormComponent,
        ContaContabilTableComponent,
        ContaContabilListComponent,
        ContaContabilCodigoPipe,
        ContaContabilCodigoMaskDirective
    ],
    exports: [
        ContaContabilTableComponent,
        ContaContabilCodigoMaskDirective,
        ContaContabilCodigoPipe
    ]
})
export class ContaContabilModule {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/conta-contabil.module.ts
 **/